import { render, staticRenderFns } from "./PageTile.vue?vue&type=template&id=4f122715&"
import script from "./PageTile.vue?vue&type=script&lang=js&"
export * from "./PageTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports